import { render, staticRenderFns } from "./alert-type-modification.vue?vue&type=template&id=7af86ffb"
import script from "./alert-type-modification.vue?vue&type=script&lang=js"
export * from "./alert-type-modification.vue?vue&type=script&lang=js"
import style0 from "./alert-type-modification.vue?vue&type=style&index=0&id=7af86ffb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports